<template>
  <router-view class="g-container"></router-view>
</template>

<script>
  export default {
    name: 'App',
  };
</script>
